import { render, staticRenderFns } from "./ProfileAffiliate.vue?vue&type=template&id=2fde1476&scoped=true&"
import script from "./ProfileAffiliate.vue?vue&type=script&lang=ts&"
export * from "./ProfileAffiliate.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileAffiliate.vue?vue&type=style&index=0&id=2fde1476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde1476",
  null
  
)

export default component.exports